module.exports = __webpack_public_path__ + "img/jun.6b04734d.jpg";